'use strict';

export default (API) => ({
    schedules: {
        get: (establishmentId, availabilityId) => {
            const url = 'api/v5/establishments/' + establishmentId + '/availabilities/' + availabilityId;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAll: (establishmentId, dateStart, dateStop, places = null, services = null, resources = null, clientTimeZone = null, appointmentId = null) => {
            const url = 'v3/establishments/' + establishmentId +
                '/availabilities?dateStart=' + dateStart +
                '&dateStop=' + dateStop +
                (places ? '&places=' + places.join(',') : '&places=') +
                (services ? '&services=' + services.join(',') : '&services=') +
                (resources ? '&resources=' + resources.join(',') : '&resources=') +
                (clientTimeZone ? '&timezone=' + clientTimeZone : '') +
                (appointmentId ? '&appointmentId=' + appointmentId : '');

            const request = API.http.get(url);
            return API.handleError(request);
        },
        getAllForPlace: (establishmentId, place, dateStart, dateStop, light = false, serviceId = null) => {
            const url = 'v3/establishments/' + establishmentId +
                '/availabilities?dateStart=' + dateStart +
                '&dateStop=' + dateStop +
                '&places=' + place +
                '&light=' + light +
                (serviceId ? '&services=' + serviceId : '');

            const request = API.http.get(url);
            return API.handleError(request);
        },
        getFirstAvailabilityNextYear: (establishmentId, places, service, filters = null, clientTimeZone = null, dateStart = null, dateStop = null, gapMode = false, gapHeadOfficeId = null) => {
            const url = 'v3/establishments/' + establishmentId +
                '/availabilities/first?places=' + places +
                '&service=' + service +
                (clientTimeZone ? '&timezone=' + clientTimeZone : '') +
                (filters
                    ? (filters[0] !== null ? '&filter1=' + filters[0] : '') +
                    (filters[1] !== null ? '&filter2=' + filters[1] : '') +
                    (filters[2] !== null ? '&filter3=' + filters[2] : '')
                    : ''
                ) +
                (dateStart ? '&dateStart=' + dateStart : '') +
                (dateStop ? '&dateStop=' + dateStop : '') +
                '&gapMode='+ gapMode +
                ((gapMode && gapHeadOfficeId) ? '&gapHeadOfficeId='+ gapHeadOfficeId : '');

            const request = API.http.get(url);
            return API.handleError(request);
        },
        getPublicSchedule: (establishmentId, dateStart, dateStop, service, place = null, filters = null, clientTimeZone = null, gapMode = false, gapHeadOfficeId = null) => {
            const url = 'v3/establishments/' + establishmentId +
                '/schedules/public?dateStart=' + dateStart +
                '&dateStop=' + dateStop +
                '&service=' + service +
                (clientTimeZone ? '&timezone=' + clientTimeZone : '') +
                (place ? '&places=' + place : '') +
                (filters ? (filters[0] !== null ? '&filter1=' + filters[0] : '') +
                (filters[1] !== null ? '&filter2=' + filters[1] : '') +
                (filters[2] !== null ? '&filter3=' + filters[2] : '') : '') +
                '&gapMode='+ gapMode +
                ((gapMode && gapHeadOfficeId) ? '&gapHeadOfficeId='+ gapHeadOfficeId : '');

            const request = API.http.get(url);
            return API.handleError(request);
        },
        getClosestSchedule: (establishmentId, dateTarget, dateStart, dateStop, service, place = null, filters = null, clientTimeZone = null, limit = null, minResourceCount = null, gapMode = false, gapHeadOfficeId = null) => {
            const url = 'v3/establishments/' + establishmentId +
                '/schedules/next?dateTarget=' + dateTarget +
                '&dateStart=' + dateStart +
                '&dateStop=' + dateStop +
                '&service=' + service +
                (clientTimeZone ? '&timezone=' + clientTimeZone : '') +
                (place ? '&places=' + place : '') +
                (limit ? '&limit=' + limit : '') +
                (minResourceCount ? '&resourceCount=' + minResourceCount : '') +
                (filters ? (filters[0] !== null ? '&filter1=' + filters[0] : '') +
                (filters[1] !== null ? '&filter2=' + filters[1] : '') +
                (filters[2] !== null ? '&filter3=' + filters[2] : '') : '')+
                '&gapMode='+ gapMode +
                ((gapMode && gapHeadOfficeId) ? '&gapHeadOfficeId='+ gapHeadOfficeId : '');

            const request = API.http.get(url);
            return API.handleError(request);
        },
        getCompletePublicPeriodSchedule: (establishmentId, dateStart, dateStop, service, place = null, filters = null, clientTimeZone = null, gapMode = false, gapHeadOfficeId = null) => {
            const url = 'v3/establishments/' + establishmentId +
                '/schedules/day?dateStart=' + dateStart +
                '&dateStop=' + dateStop +
                '&service=' + service +
                (clientTimeZone ? '&timezone=' + clientTimeZone : '') +
                (place ? '&places=' + place : '') +
                (filters ? (filters[0] !== null ? '&filter1=' + filters[0] : '') +
                (filters[1] !== null ? '&filter2=' + filters[1] : '') +
                (filters[2] !== null ? '&filter3=' + filters[2] : '') : '')+
                '&gapMode='+ gapMode +
                ((gapMode && gapHeadOfficeId) ? '&gapHeadOfficeId='+ gapHeadOfficeId : '');

            const request = API.http.get(url);
            return API.handleError(request);
        },
        createBatch(establishmentId, params) {
            const url = 'v3/establishments/' + establishmentId + '/availabilities/';
            const request = API.http.post(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        updateBatch(establishmentId, params) {
            let url = 'v3/establishments/' + establishmentId + '/availabilities';
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        },
        deleteBatch(establishmentId, params) {
            const url = 'v3/establishments/' + establishmentId + '/availabilities?ids=' + params;
            const request = API.http.delete(url);
            return API.handleError(request);
        },
        getDaysWithAvailability(establishmentId, place, dateStart, dateStop, timezone = null, service = null, appointmentId = null) {
            let url = 'v3/establishments/' + establishmentId + '/schedules/daysWithAvailability?dateStart=' + dateStart + '&dateStop=' + dateStop + '&places=' + place;
            url += timezone ? '&timezone=' + timezone : '';
            url += service ? '&service=' + service : '';
            url += appointmentId ? '&appointmentId=' + appointmentId : '';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getMonthInfoByPlace(establishmentId, placesIds, resourceIds, servicesIds, dateStart, dateStop, timezone = null) {
            let url = `v3/establishments/${establishmentId}/schedules?dateStart=${dateStart}&dateStop=${dateStop}&places=${placesIds}&resources=${resourceIds}&services=${servicesIds}`;
            url += timezone ? `&timezone=${timezone}` : '';
            const request = API.http.get(url);
            return API.handleError(request);
        },
        getReconstructedAvailsForDay(establishmentId, placeId, date, timezone) {
            const url = 'v3/establishments/' + establishmentId + '/places/' + placeId + '/availabilities/reconstructed?date=' + date + '&timezone=' + timezone;
            const request = API.http.get(url);
            return API.handleError(request);
        },
        toggleDay(establishmentId, params) {
            const url = 'v3/establishments/' + establishmentId + '/availabilities/toggleDay';
            const request = API.http.put(url, params, { headers: { 'Content-Type': 'application/json' } });
            return API.handleError(request);
        }
    }
});
